import React, { useEffect } from 'react';

function QuickExit() {
  const exitSite = () => {
    // Redirect to a safe site
    window.location.replace('https://weather.com');
  };

  useEffect(() => {
    // Add event listener for ESC key
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        exitSite();
      }
    };
    
    document.addEventListener('keydown', handleKeyDown);
    
    // Cleanup
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <button 
      onClick={exitSite}
      className="quick-exit-button"
      aria-label="Exit site quickly"
      title="Click to quickly exit to a weather site"
    >
      Quick Exit
    </button>
  );
}

export default QuickExit;